import React from 'react';
import { CardBody } from 'reactstrap';
import {
	_capitalizeText,
	_formatNumber,
	_getBuildingURL,
	BuildingPhoto,
	_replaceAbbreviations,
} from '../../../shared/helpers/utils';
import BuildingIcons from '../../../shared/components/BuildingIcons';

const PropertyGridView = ({ data, onBuildingClick }) => {
	return (
		<div className="catalog-items__wrap">
			<div className="catalog-items">
				{data.map((d) => (
					<CardBody
						className="catalog-item"
						key={d.id}
						onClick={(e) => onBuildingClick(e, d)}
						style={{ cursor: 'pointer' }}
					>
						<div className="catalog-item__img-wrap">
							<BuildingPhoto item={d} />
						</div>
						<div className="catalog-item__info">
							<h4 className="catalog-item__price">
								{d.name ? _capitalizeText(d.name) : _capitalizeText(_replaceAbbreviations(d.display_full_street_address))}
								<BuildingIcons building={d} />
								{d.building_name && (
									<div>{_capitalizeText(_replaceAbbreviations(d.display_full_street_address))}</div>
								)}
								<div className="light-text small-text" style={{ color: '#858AA1' }}>
									{d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''}
									{_capitalizeText(d.borough)}
								</div>
							</h4>
							<h5 className="product-card__title">
								{d.building_class && (
									<span className="light-text small-text">{d.building_class}</span>
								)}
								{d.building_class && d.total_units > 0 && <span className="small-divider">|</span>}
								{d.total_units > 0 && (
									<span className="light-text small-text">{_formatNumber(d.total_units)} Units</span>
								)}
								{d.total_floors > 0 && <span className="small-divider">|</span>}
								{d.total_floors > 0 && (
									<span className="light-text small-text">{_formatNumber(d.total_floors)} Floors</span>
								)}
							</h5>
							{d.owner && (
								<div className="light-text small-text" style={{ fontSize: 11, color: '#A3ADC2', marginTop: 2 }}>
									{_capitalizeText(d.owner)}
								</div>
							)}
						</div>
					</CardBody>
				))}
			</div>
		</div>
	);
};

export default PropertyGridView;
